/**
 * Version information for fernhill
 * Auto-generated by sharpee - DO NOT EDIT
 */
export const STORY_VERSION = '0.3.0';
export const BUILD_DATE = '2026-10-27T06:27:37Z';
export const VERSION_INFO = { version: STORY_VERSION, buildDate: BUILD_DATE } as const;
